const chorddata = [
    [
        1198,
        310,
        1605,
        348,
        44
    ],
    [
        78,
        793,
        47,
        400,
        510
    ],
    [
        1702,
        202,
        76,
        1867,
        381
    ],
    [
        3,
        125,
        159,
        382,
        1504
    ],
    [
        97,
        137,
        1646,
        421,
        653
    ]
]
export default chorddata;